// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + ".js?" + "8e54eb86debfd401c8e1" + "";
};